import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import {
  AddComment,
  WatsonHealthICa_2D,
  Settings,
  CarbonIconType,
  Slisor
} from '@carbon/icons-react';
import { colorSet, theme } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';

const FakeButtons = () => {
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  const [clientWidth, setClientWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setClientWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const left = matches ? '50%' : (clientWidth - 299 - 69) / 2 + 299;

  return (
    <Box
      position={'absolute'}
      bottom={matches ? 16 : 32}
      left={left}
      width={matches ? 324 : 380}
      height={matches ? 85 : 90}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      gridGap={matches ? 0 : 8}
      bgcolor={colorSet.gray000}
      padding={1}
      borderRadius={12}
      boxShadow={theme.shadows[1]}
      style={{
        transform: matches ? `translateX(-50%)` : `translateX(-50%)`
      }}
    >
      {mockIconButtons.map(({ Icon, description }, index) => (
        <Box
          key={description}
          id={`fake-button-${index}`}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          gridGap={4}
          width={66}
          height={70}
        >
          <Icon size={32} color={colorSet.gray600} />
          <CustomizedTypography variant="caption" color={'textSecondary'}>
            {description}
          </CustomizedTypography>
        </Box>
      ))}
    </Box>
  );
};

export default FakeButtons;

const mockIconButtons: { Icon: CarbonIconType; description: string }[] = [
  { Icon: AddComment, description: '주석달기' },
  { Icon: WatsonHealthICa_2D, description: '화면맞춤' },
  { Icon: Slisor, description: '단면설정' },
  { Icon: AddComment, description: '펼쳐보기' },
  { Icon: Settings, description: '설정' }
];
